import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { LexileGrowthByGradeReportData } from 'teacher-ui-client/components/giraffe/charts/dashboard/lexile-growth'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface LexileGrowthResponse {
  lexile_growth_by_grade: {
    grades: {
      grade_position: number
      student_count: number
      from_lexile_growth: number
      to_lexile_growth: number
    }[]
    student_count: number
  }
}

export async function lexileGrowth(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<LexileGrowthByGradeReportData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('lexile_growth_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<LexileGrowthResponse>(url, query)
  if (!data) return null

  const {
    lexile_growth_by_grade: { grades, student_count },
  } = data

  if (grades.length === 0) return null

  const filteredLexileGrowth = grades
    .filter((grade) => grade.grade_position !== null)
    .sort((a, b) => a.grade_position - b.grade_position)

  return {
    grades: filteredLexileGrowth,
    student_count,
  }
}
